<div class="filters-container" [class.compact]="compact">
  <div class="filter-field">
    @if (!compact) {
      <label>{{ "Sample Statuses" | translate }}</label>
    }
    <mat-form-field appearance="outline" class="filter-select">
      <mat-select
        [ngModel]="values.selectedStatuses"
        (ngModelChange)="onStatusesChange($event)"
        multiple
        [placeholder]="'All Statuses' | translate"
        >
        @for (opt of statusOptions; track trackByIndex($index)) {
          <mat-option
            [value]="opt.value"
            >{{ opt.label | translate }}</mat-option
            >
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-field filter-field-wide">
      @if (!compact) {
        <label>{{ "Date Range" | translate }}</label>
      }
      <mat-form-field appearance="outline" class="filter-select">
        <mat-select
          [value]="values.dateFilterType"
          (valueChange)="onDateFilterChange($event)"
          [placeholder]="'All Dates' | translate"
          >
          @for (opt of dateRangeOptionsWithRange; track trackByIndex($index)) {
            <mat-option
              [value]="opt.value"
              >{{ opt.value === DateFilterTypeEnum.Custom ? customDateLabel : opt.displayName }}</mat-option
              >
            }
          </mat-select>
          @if (values.dateFilterType === DateFilterTypeEnum.Custom) {
            <button
              matSuffix mat-icon-button
              type="button"
              (click)="$event.stopPropagation(); openCustomDateDialog(values.dateFilterType)"
              [attr.aria-label]="'Edit custom date range' | translate">
              <mat-icon>edit_calendar</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>

      <ng-content select="[filterAppend]"></ng-content>
    </div>
